'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondsAgo.js
// module id = 209
// module chunks = 0